import React, { useContext, useEffect, useState } from 'react';
import PaymentSettingsLink from '../components/paymentSettings/PaymentSettingsLink';
import { BadgeEuro, BarChart3, Clock, GitCompare, TrendingUp, Users, X } from 'lucide-react';
import ModalComparateur from '../components/ModalComparateur';
import { useSocket } from '../Context/SocketContext';
import { infoUser } from '../utils/auth';
import AppContext from '../Context/AppContext';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import SideLeft from '../layout/SideLeft';
import StatProjects from '../components/StatProjects';
import WidGetDateSelect from '../componentsWidgets/WidGetDateSelect';
import TabPaiementItem from '../libraries/TabPaiementItem';
import WidgetPaiementStat from '../componentsWidgets/WidgetPaiementStat';
import WidgetSendNotif from '../componentsWidgets/WidgetSendNotif';

const Paiement = () => {
    const { socket, setNotifAskPaiement } = useSocket();
    const { setCurrentPage } = useContext(AppContext)
    const user = infoUser();
    const [result, setResult] = useState(null)
    const [date, setDate] = useState(new Date())
    const [selectStatus, setSelectStatus] = useState('tous')
    const [showStats, setShowStats] = useState(false)
    const [selectType, setSelectType] = useState(null)
    const [showCompare, setShowCompare] = useState(false)

    const init = (d) => {
        setCurrentPage('paiement')
        setNotifAskPaiement(null)
        if (socket) {
            socket.on('notif_new_paiement', (e) => {
                //init()
            })
            socket.on('notif_confirm_paiement', (e) => {
                //init()
            })
            socket && socket.emit('empire_tracker_list_ask_paiement', { token: user.expecttoken, date: d || date }, (e) => {
                setSelectStatus('tous')
                setResult(e)
                console.log(e);
            })
        }
    }
    const itemSelectedStatus = () => {
        if (selectStatus && result) {
            const findBySelect = result.find(e => e.status == selectStatus);
            if (findBySelect) {
                return findBySelect.data;
            }
        }
        return []
    }

    const getData = (status) => result?.find(e => e.status === status)?.data || []
    const sumPrice = (data) => data.reduce((acc, s) => acc + (parseFloat(s.price) || 0), 0)

    const doneData = getData('done')
    const paidData = getData('paid')
    const totalDone = sumPrice(doneData)
    const totalPaid = sumPrice(paidData)
    const nbAbo = doneData.length
    const panierMoyen = nbAbo > 0 ? totalDone / nbAbo : 0

    const TYPES = [
        { key: 'streaming', label: 'Streaming' },
        { key: 'sport', label: 'Sport' },
        { key: 'premium', label: 'Premium' },
        { key: 'vitrine', label: 'Vitrine' },
    ]
    const typeOf = (s) => s.type || 'streaming'
    const doneCountByType = (t) => doneData.filter(s => typeOf(s) === t).length
    const doneTotalByType = (t) => sumPrice(doneData.filter(s => typeOf(s) === t))
    const shownItems = itemSelectedStatus().filter(s => !selectType || typeOf(s) === selectType)

    useEffect(() => {
        init()
    }, [socket])
    return (
        <MainLayout>
            <CenterLayout>
                <div className='df fdc' style={{ height: '100%' }}>
                    <div className='df aic jcsb fw gap1 mb1'>
                        <WidGetDateSelect date={date} setDate={(d) => {
                            setDate(d)
                            init(d)
                        }} />
                        <button onClick={() => setShowCompare(true)} className='btn cs df aic gap1'>
                            <GitCompare size={16} color='#fff' /> Comparateur
                        </button>
                    </div>
                    {result?.length > 0 && (
                        <>
                            <nav className='df gap1 aic paiement-status-nav'>
                                {result.map((s, i) => (
                                    <button onClick={() => {
                                        setSelectStatus(s.status)
                                    }} key={i + "btn-status-date"} className={`card carder cw ttc twn ${selectStatus == s.status ? "active" : ""}`}>{s.status}</button>
                                ))}
                            </nav>

                            {/** FILTRE PAR TYPE (total done) */}
                            <nav className='df gap1 aic fw mt1 paiement-type-nav'>
                                {TYPES.map((t) => (
                                    <button key={t.key}
                                        onClick={() => setSelectType(prev => prev === t.key ? null : t.key)}
                                        className={`type-filter df aic gap1 ${selectType === t.key ? "active" : ""}`}>
                                        {t.label}
                                        <span className='type-count'>{doneCountByType(t.key)}</span>
                                        {doneTotalByType(t.key) > 0 && (
                                            <span className='type-total'>{doneTotalByType(t.key).toFixed(2)}€</span>
                                        )}
                                    </button>
                                ))}
                            </nav>

                            {/** LIST */}
                            <div className='paiement-list'>
                                {shownItems?.length > 0 && shownItems.map((s, i) => (
                                    <TabPaiementItem key={i + "__item_paiement_list"} s={s} init={init} index={i} />
                                ))}
                            </div>
                            {/** STATS — bouton latéral + panneau coulissant */}
                            <button onClick={() => setShowStats(true)} className='paiement-stats-fab' aria-label="Statistiques">
                                <BarChart3 size={22} color='#fff' />
                            </button>
                            <div className={`paiement-stats-overlay ${showStats ? "show" : ""}`} onClick={() => setShowStats(false)}></div>
                            <div className={`paiement-stats-panel ${showStats ? "open" : ""}`}>
                                <div className='df aic jcsb mb2'>
                                    <p className='fb cw fs18'>Statistiques</p>
                                    <button onClick={() => setShowStats(false)} className='pay-act-btn' aria-label="Fermer"><X size={18} color='#fff' /></button>
                                </div>
                                <div className='df fdc gap1'>
                                    <div className='stat-card'>
                                        <div className='stat-icon green'><BadgeEuro color='#15992f' size={18} /></div>
                                        <div className='df fdc'>
                                            <span className='stat-label fr cw'>Total validé</span>
                                            <span className='stat-value fb cw'>{totalDone.toFixed(2)}€</span>
                                        </div>
                                    </div>
                                    <div className='stat-card'>
                                        <div className='stat-icon violet'><Users color='#9754e3' size={18} /></div>
                                        <div className='df fdc'>
                                            <span className='stat-label fr cw'>Abonnements</span>
                                            <span className='stat-value fb cw'>{nbAbo}</span>
                                        </div>
                                    </div>
                                    <div className='stat-card'>
                                        <div className='stat-icon orange'><Clock color='#f27936' size={18} /></div>
                                        <div className='df fdc'>
                                            <span className='stat-label fr cw'>À venir</span>
                                            <span className='stat-value fb cw'>{totalPaid.toFixed(2)}€</span>
                                        </div>
                                    </div>
                                    <div className='stat-card'>
                                        <div className='stat-icon blue'><TrendingUp color='#0074dc' size={18} /></div>
                                        <div className='df fdc'>
                                            <span className='stat-label fr cw'>Panier moyen</span>
                                            <span className='stat-value fb cw'>{panierMoyen.toFixed(2)}€</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </CenterLayout>
            <SideLeft>

                <StatProjects open={(cmp) => { }} />
                {socket && (
                    <>
                        <p className='fm cw mb1 fs20'>Abonnements</p>
                        <div className="df fdc gap1">
                            <WidgetPaiementStat status={"done"} label="Paiement validé" />
                            <WidgetPaiementStat status={"paid"} label="Paiement à venir" />
                        </div>
                        <p className='fm cw mb1 fs20 '>Paramettre</p>
                        <PaymentSettingsLink />
                        <p className='fm cw mb1 fs20'>Notif</p>
                        <WidgetSendNotif sign='N' label={"Envoyer une notif"} />
                    </>
                )}
            </SideLeft>

            {showCompare && <ModalComparateur onClose={() => setShowCompare(false)} />}
        </MainLayout>
    );
};

export default Paiement;